import * as DialogPrimitive from "@radix-ui/react-dialog"
import * as React from "react"

export const Dialog = DialogPrimitive.Root
export const DialogTrigger = DialogPrimitive.Trigger
export const DialogClose = DialogPrimitive.Close

export function DialogContent({ className, ...props }: React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/50" />
      <DialogPrimitive.Content
        className={[
          "fixed z-50 grid w-full max-w-2xl gap-4 border bg-background p-6 shadow-lg",
          "rounded-md",
          "left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
          className || "",
        ].join(" ")}
        {...props}
      />
    </DialogPrimitive.Portal>
  )
}

export function DialogHeader({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={["flex flex-col space-y-1.5", className || ""].join(" ")} {...props} />
}

export function DialogFooter({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={["flex items-center justify-between gap-2", className || ""].join(" ")} {...props} />
}

export function DialogTitle({ className, ...props }: React.ComponentPropsWithoutRef<typeof DialogPrimitive.Title>) {
  return <DialogPrimitive.Title className={["text-lg font-heading font-semibold", className || ""].join(" ")} {...props} />
}

export function DialogDescription({ className, ...props }: React.ComponentPropsWithoutRef<typeof DialogPrimitive.Description>) {
  return <DialogPrimitive.Description className={["text-sm text-muted-foreground", className || ""].join(" ")} {...props} />
}


